import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {loadCustomConfigurations, saveCustomConfiguration} from './custom-configuration.actions';
import {selectHierarchicalTableColumns, selectTableColumns} from './custom-configuration.selectors';
import {Observable} from 'rxjs';
import {CustomConfiguration} from './custom-configuration.reducer';

@Injectable({
  providedIn: 'root'
})
export class CustomConfigurationFacadeService {

  constructor(private store: Store) {
  }

  load() {
    this.store.dispatch(loadCustomConfigurations());
  }

  save(change: Partial<CustomConfiguration>) {
    this.store.dispatch(saveCustomConfiguration({config: change}));
  }

  selectTableColumns(): Observable<string[]> {
    return this.store.select(selectTableColumns);
  }

  selectHierarchicalTableColumns(): Observable<string[]> {
    return this.store.select(selectHierarchicalTableColumns);
  }
}
